export const GET_ESTIMATE_STATUS_ACTION = "GET_ESTIMATE_STATUS_ACTION";

export const ESTIMATE_LIST_ACTION = "ESTIMATE_LIST_ACTION";
export const ESTIMATE_WRITE_ACTION = "ESTIMATE_WRITE_ACTION";
